import axios from "axios";
import { BASE_URL1 } from "../Services/APIRequest";

const API_BASE_URL = BASE_URL1.trim().replace(/\/$/, "");

function requestConfig() {
  return {
    headers: {
      "Cache-Control": "no-cache",
      Authorization: localStorage.getItem("loginToken"),
    },
  };
}

function unwrapResponse(response) {
  if (!response.data?.isSuccess) {
    throw new Error(response.data?.message || "The request could not be completed.");
  }

  return response.data.result;
}

export async function getAssignedDistributors(userId) {
  return unwrapResponse(
    await axios.get(`${API_BASE_URL}/User/GetDistributorsAssignedToUser/${userId}`, requestConfig()),
  );
}

export async function getAvailableProducts(distributorId) {
  return unwrapResponse(
    await axios.get(`${API_BASE_URL}/SeedBookingOrder/GetAvailableProducts/${distributorId}`, requestConfig()),
  );
}

export async function getActiveCart(distributorId) {
  return unwrapResponse(
    await axios.get(`${API_BASE_URL}/SeedBookingOrder/GetActiveCart/${distributorId}`, requestConfig()),
  );
}

export async function saveCartItem(item) {
  return unwrapResponse(
    await axios.post(`${API_BASE_URL}/SeedBookingOrder/SaveCartItem`, item, requestConfig()),
  );
}

export async function removeCartItem(item) {
  return unwrapResponse(
    await axios.post(`${API_BASE_URL}/SeedBookingOrder/RemoveCartItem`, item, requestConfig()),
  );
}

export async function submitSeedBookingOrder(order) {
  return unwrapResponse(
    await axios.post(`${API_BASE_URL}/SeedBookingOrder/SubmitOrder`, order, requestConfig()),
  );
}

export async function getSeedBookingOrderSummary(orderLineId) {
  return unwrapResponse(
    await axios.get(`${API_BASE_URL}/SeedBookingOrder/GetOrderSummary/${orderLineId}`, requestConfig()),
  );
}

export async function getSeedBookingOrders(distributorId) {
  return unwrapResponse(
    await axios.get(
      `${API_BASE_URL}/SeedBookingOrder/GetOrders`,
      { ...requestConfig(), params: { distributorId } },
    ),
  );
}

export async function getAssignedSeedBookingOrders() {
  return unwrapResponse(
    await axios.get(
      `${API_BASE_URL}/SeedBookingOrder/GetOrdersForAssignedDistributors`,
      requestConfig(),
    ),
  );
}

export async function reviewSeedBookingOrder(request) {
  return unwrapResponse(
    await axios.post(`${API_BASE_URL}/SeedBookingOrder/ReviewOrder`, request, requestConfig()),
  );
}

export function getSeedBookingErrorMessage(error) {
  return error.response?.data?.message || error.message || "Something went wrong. Please try again.";
}